
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headless-cms/comparison",
      function () {
        return require("private-next-pages/headless-cms/comparison/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headless-cms/comparison"])
      });
    }
  